import React from 'react';
import { useAtomValue } from 'jotai';
import useShareSet from '@components/share/useShareSet';
import { metricPanelShareAtom } from '@components/metrics-panel-hz/atoms';
import { panelsAtom } from '@src/atoms/panels';
import { diagnosticsAtom } from '@src/atoms/toggles';

// ideally share data should be set by each section/component like export
// because of the large redux state on old trends it's difficult to break it up now
// we should do it after depricating old trends

function LatchShare({ sharingState, pageKey }) {
  const metricPanel = useAtomValue(metricPanelShareAtom);
  const sections = useAtomValue(panelsAtom);
  const diagnostics = useAtomValue(diagnosticsAtom);

  const { state, ...meta } = sharingState;

  const formattedState = {
    ...meta,
    state: {
      ...state,
      metricPanel,
      toggles: {
        sections,
        diagnostics,
      },
    },
  };

  useShareSet({ pageKey, state: formattedState });

  return <></>;
}

export default LatchShare;
